import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ConfirmationRateBadge from './ConfirmationRateBadge';
import { formatCurrency } from 'Helpers/UiHelper';

const StatusCard = ({ label, value, color, onClick }) => (
  <Card className="h-100 shadow-sm border-0" style={{ cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>
    <Card.Body className="text-center py-3">
      <div style={{ fontSize: '1.5rem', fontWeight: 700, color }}>{value}</div>
      <div
        style={{
          fontSize: '0.7rem',
          fontWeight: 700,
          textTransform: 'uppercase',
          color: '#888',
          letterSpacing: '0.5px',
          marginTop: '2px',
        }}
      >
        {label}
      </div>
    </Card.Body>
  </Card>
);

StatusCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

const SummaryCardsV2 = ({ summary }) => {
  const navigate = useNavigate();

  const {
    total = 0,
    new: newCount = 0,
    pendinghr = 0,
    pendingbtt = 0,
    pendingdes = 0,
    confirmed = 0,
    confirmationRate = 0,
    totalSpend = 0,
  } = summary || {};

  return (
    <Row className="g-2 mb-3">
      <Col xs={6} sm={4} lg>
        <StatusCard label="Total Tickets" value={total} color="#4e73df" onClick={() => navigate('/all')} />
      </Col>
      <Col xs={6} sm={4} lg>
        <StatusCard label="New" value={newCount} color="#36b9cc" onClick={() => navigate('/new')} />
      </Col>
      <Col xs={6} sm={4} lg>
        <StatusCard label="Pending HR" value={pendinghr} color="#f6c23e" onClick={() => navigate('/pendinghr')} />
      </Col>
      <Col xs={6} sm={4} lg>
        <StatusCard label="Pending BTT" value={pendingbtt} color="#f6c23e" onClick={() => navigate('/pendingbtt')} />
      </Col>
      <Col xs={6} sm={4} lg>
        <StatusCard label="Pending DES" value={pendingdes} color="#f6c23e" onClick={() => navigate('/pendingdes')} />
      </Col>
      <Col xs={6} sm={4} lg>
        <StatusCard label="Confirmed" value={confirmed} color="#1cc88a" onClick={() => navigate('/confirmed')} />
      </Col>
      <Col xs={6} sm={4} lg>
        <Card className="h-100 shadow-sm border-0">
          <Card.Body className="text-center py-3">
            <div style={{ fontSize: '1.5rem', fontWeight: 700, lineHeight: 1 }}>
              <ConfirmationRateBadge rate={confirmationRate} />
            </div>
            <div
              style={{
                fontSize: '0.7rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                color: '#888',
                letterSpacing: '0.5px',
                marginTop: '6px',
              }}
            >
              Conf. Rate
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={6} sm={4} lg>
        <StatusCard label="Total Spend" value={formatCurrency(totalSpend)} color="#1cc88a" />
      </Col>
    </Row>
  );
};

SummaryCardsV2.propTypes = {
  summary: PropTypes.shape({
    total: PropTypes.number,
    new: PropTypes.number,
    pendinghr: PropTypes.number,
    pendingbtt: PropTypes.number,
    pendingdes: PropTypes.number,
    confirmed: PropTypes.number,
    confirmationRate: PropTypes.number,
    totalSpend: PropTypes.number,
  }).isRequired,
};

export default SummaryCardsV2;
